import styled from "styled-components/macro";

const UlNoBullets = styled.ul`
  list-style: none;
`;

export default UlNoBullets;
